import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
//import { defineCustomElements } from '@ionic/pwa-elements/loader';
//import { Plugins } from '@capacitor/core';

ReactDOM.render(<App />, document.getElementById('root'));
/*defineCustomElements(window).then(r => {
  /!*const { LocalNotifications } = Plugins;
  LocalNotifications.schedule({
    notifications: [
      {
        title: "Prueba",
        body: "Esta es una notificación",
        id: 1,
        schedule: { at: new Date(Date.now() + 1000 * 10)  },
        sound: null,
        attachments: null,
        actionTypeId: "",
        extra: null
      }
    ]
  });*!/
});*/
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
